<template>
<div class="chapter">
<div class="inner_page">
<article epub:type="chapter">
<div class="bodymatter" epub:type="bodymatter">
<section epub:type="division" id="c06">
<div class="chbrd">
<h1 class="chapter_date"><a id="page22"></a><strong>c. 530 BCE</strong></h1>
<h1 class="chapter_title">Anthropomorphization</h1>
<p class="bauthorb"><strong>Xenophanes</strong> (c. 570–c. 470 BCE)</p>
</div>
<p class="nonindent">Homer (fl. c. ninth or eighth century BCE) was more than a poet to the ancient Greeks. He was a revered moral and religious sage. It therefore must have created quite a stir when Xenophanes, a traveling philosopher-poet, attacked him with both guns blazing.</p>
<p class="indent">Xenophanes accused Homer of maligning the gods by casting them in human shape and endowing them with moral failings, such as theft and adultery. He noted that humans anthropomorphize the gods, imagining that they “are born and have clothes and voices and shapes like their own,” but Xenophanes believed this is simply a human conceit. For “if oxen, horses, and lions had hands or could paint with their hands and fashion works as men do, horses would paint horse-like images of gods and oxen oxen-like ones, and each would fashion bodies like his own.”</p>
<p class="indent">Xenophanes was born around 570 BCE in Colophon, a city about fifty miles north of Miletus in Asia Minor. When the Medes conquered Colophon in 546 BCE, Xenophanes was expelled and fled west. He spent the rest of his long life as a wandering bard, primarily in Italy and Sicily, reciting his own poems as well as others’. Perhaps it was during his travels that it dawned on him how humans everywhere seemed to shape the gods in their own image. As he wryly noted, “the Ethiopians consider the gods flat-nosed and black; the Thracians blue-eyed and red-haired.”</p>
<p class="indent">In truth, Xenophanes believed “there is one god, among gods and men the greatest, not at all like mortals in body or mind.” Some scholars believe that Xenophanes identified god with the world, viewing the entire cosmos as a living, conscious, and divine being. If so, he would be the first Western philosopher to embrace a form of pantheism.</p>
<p class="indent">Refreshingly, Xenophanes was modest about his philosophical and religious musings. He wrote, “Certain truth no man has seen, nor will there ever be a man who knows about the gods and about everything of which I speak; for even if he should fully succeed in saying what is true, even so he himself does not <em>know</em> it, but in all things there is opinion.”</p>
<p class="captionl" id="img23"><em>In ancient Greece, the gods were usually depicted in idealized human form—a fallacy according to Xenophanes—such as in this c. 400 BCE votive frieze known as the</em> Relief of the Gods <em>from the Sanctuary of Artemis at Brauron, in southeastern Greece. From left to right are Zeus, Leto, and their children Apollo and Artemis.</em></p>
<div class="dis_imgb"><a id="page23"></a><img alt="" src="OEBPS/images/23-1.jpg"/></div>
<div class="xref">
<p class="seal"><span class="sls"><strong>SEE ALSO</strong></span> <a class="hlink" href="#/OEBPS/9781454935575_c02">Birth of Western Philosophy (c. 585 BCE)</a></p>
</div>
</section>
</div>
</article>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781454935575_c06.vue?b49445ee